import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import ActionableFilterPill from '../../index';
import { SHIPPING_ACCOUNT } from '../../../../filters/constants';

const getDisplayName = (appliedFilters = [], accounts, labelProviders) => {
  const shippingAccounts = appliedFilters?.filter((currentFilter) => currentFilter.filterById === SHIPPING_ACCOUNT);

  if (shippingAccounts?.length === 0) {
    return <FormattedMessage defaultMessage='Shipping Account' description='default label for shipping account filter' id='blnxbo' />;
  }

  if (shippingAccounts.length === 1) {
    const matchingShippingAccount = accounts.find(
      (account) => account?.sellerLabelProviderId === shippingAccounts[0]?.criterionArgumentValue,
    );
    const labelProviderName = labelProviders.find(
      (provider) => provider.labelProviderId === matchingShippingAccount?.labelProviderId,
    )?.name;
    const shippingAccountName = matchingShippingAccount?.name ? matchingShippingAccount.name : labelProviderName;
    return shippingAccountName;
  }

  return (
    <FormattedMessage
      defaultMessage='(Multiple Accounts)'
      description='label for shipping account filter when there a more than on selected'
      id='r7Fnft'
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const accounts = Global.selectSellerLabelProviders(state);
  const labelProviders = Global.selectReferenceDatagetProviders(state);
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters, accounts, labelProviders),
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
